import { default as TierContentSubmit } from './TierContentSubmit';
import { default as TierContentSubmitContainer } from './TierContentSubmit.container';

export default TierContentSubmitContainer(TierContentSubmit);
